module.exports = __webpack_public_path__ + "static/assets/7f2a081e30324926b38a1785fe8a3a3b.svg";